import DOMPurify from 'dompurify'
import Linkify from 'linkify-react'

import { styled } from '@mui/material'
import { colors } from '@theme/variables'

const validateUrl = (text: string, type: string) => {
  if (type === 'url' && !text.startsWith('ftp://')) {
    return true
  }

  return false
}

const LinkContainer = styled('span')`
  & a {
    color: ${colors.primary};
  }
`

const options = {
  attributes: {
    rel: 'noopener noreferrer',
  },
  target: {
    url: '_blank',
  },
  validate: validateUrl,
}

export const TextWithLinks = ({ text }: { text: string }) => {
  if (typeof text !== 'string') {
    return text
  }

  const sanitizedText = DOMPurify.sanitize(text)

  return (
    <LinkContainer>
      {/* eslint-disable-next-line */}
      <Linkify options={options}>{sanitizedText}</Linkify>
    </LinkContainer>
  )
}
